import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
/* This custom hook, `usePathHistory`, utilizes React's `useEffect` and `useState` hooks along with `useLocation` from `react-router-dom` 
to track and manage the history of navigated paths within a React application. */
const usePathHistory = () => {
  const location = useLocation();
  // It initializes and empty array to store paths and updates this array wherever the location changes.
  const [pathHistory, setPathHistory] = useState([]);

  /*The hook then calculates the current and previous paths based on this array providing these values along with hardcoded titles for the previous and current locations.
 This utility is useful for tracking user navigation within an app, facilitating features like breadcrumb navigation or analytics.*/
  useEffect(() => {
    // console.log(location.pathname);
    setPathHistory((prev) => [...prev, location.pathname]);
  }, [location]);
  const currentPath = pathHistory[pathHistory.length - 1] || "/";
  const previousPath = pathHistory.length > 1 ? pathHistory[pathHistory.length - 2] : null;
  const PerviousTitle = "";
  const CurrentTitle = "";
  return { currentPath, previousPath, PerviousTitle, CurrentTitle };
};

export default usePathHistory;
